export default {
    messageConstants: {
      advocacyProactiveResponse: "advocacyProactiveResponse",
      // live chat foundation
      almeResponseType: 'AlmeResponseType',
      appeventRequest: 'AppeventRequest',
      converseRequest: 'ConverseRequest',
      getHistoryRequest: 'GetHistoryRequest',
      livechatConnectBanner: 'LiveChatConnectBanner',
      livechatDisconnectBanner: 'LiveChatDisconnectBanner',
      livechatInputType: 'LiveChatInputType',
      livechatResponseType: 'LiveChatResponseType',
      reportingEventRequest: 'ReportingEventRequest',
      userInputType: 'UserInputType',
    },
};



// WEBPACK FOOTER //
// ./settings/message-constants.ts